import { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from 'reactstrap';

const DeleteRMVendorConfirmationModal = ({
    open,
    onClose,
    onDelete,
    vendor,
}) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        if (onDelete) {
            await onDelete();
        }
        onClose();
        setLoading(false);
    };

    return (
        <Modal isOpen={open} toggle={onClose} className="miui-dialog">
            <ModalHeader toggle={onClose}>Confirm Vendor Deletion</ModalHeader>
            <ModalBody>
                <p className="mb-0">
                    Are you sure you want to delete the vendor "{vendor?.companyName && vendor?.contactName ? `${vendor.companyName} - ${vendor.contactName}` : 'this vendor'}"?
                    <br />
                    This action cannot be undone.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button
                    outline
                    className="miui-button"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button
                    color="danger"
                    className="miui-button"
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading && <Spinner size="sm" className="me-2" />}
                    Delete Vendor
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export { DeleteRMVendorConfirmationModal };
